import styled from '/web_modules/styled-components.js';
import { motion } from '/web_modules/framer-motion.js';
import { gap } from './Layout.js';
export const SongTitle = styled(motion.p).withConfig({
  displayName: "Song__SongTitle",
  componentId: "hp733e-0"
})(["font-size:18px;color:#353535;text-align:center;line-height:1.5;"]);
export const AlbumTitle = styled(motion.p).withConfig({
  displayName: "Song__AlbumTitle",
  componentId: "hp733e-1"
})(["font-size:14px;color:#6b6b6b;text-align:center;line-height:1.5;"]);
export const Song = styled(motion.button).withConfig({
  displayName: "Song",
  componentId: "hp733e-2"
})(["border:1px solid #353535;background:none;padding:32px;width:100%;position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;", " font-family:'Overpass';:after{content:'';position:absolute;display:inline-block;height:100%;width:100%;top:4px;left:4px;border:1px solid #bbb;}@media screen and (min-width:800px){margin-top:48px;min-height:150px;}"], gap('4px', 'column'));